
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * OrderRequestSourceType enum
 */
class OrderRequestSourceType {
  /**
   * Initialize enum with a given value
   * @param {OrderRequestSourceType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof OrderRequestSourceType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!OrderRequestSourceType}
   * @param {!OrderRequestSourceType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof OrderRequestSourceType)) {
      throw new TypeError('Instance of OrderRequestSourceType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!OrderRequestSourceType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!OrderRequestSourceType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === OrderRequestSourceType.UNKNOWN.value) {
      return 'UNKNOWN'
    }
    if (this.value === OrderRequestSourceType.MOBILE_APP.value) {
      return 'MOBILE_APP'
    }
    if (this.value === OrderRequestSourceType.WEB_TRADER.value) {
      return 'WEB_TRADER'
    }
    if (this.value === OrderRequestSourceType.MANAGER.value) {
      return 'MANAGER'
    }
    if (this.value === OrderRequestSourceType.SOCIAL_TRADING.value) {
      return 'SOCIAL_TRADING'
    }
    if (this.value === OrderRequestSourceType.TRADING_API.value) {
      return 'TRADING_API'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!OrderRequestSourceType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!OrderRequestSourceType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!OrderRequestSourceType} Created enum
   */
  static fromObject (other) {
    return new OrderRequestSourceType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
OrderRequestSourceType.UNKNOWN = new OrderRequestSourceType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
OrderRequestSourceType.MOBILE_APP = new OrderRequestSourceType(0 + 1)
// noinspection PointlessArithmeticExpressionJS
OrderRequestSourceType.WEB_TRADER = new OrderRequestSourceType(0 + 2)
// noinspection PointlessArithmeticExpressionJS
OrderRequestSourceType.MANAGER = new OrderRequestSourceType(0 + 3)
// noinspection PointlessArithmeticExpressionJS
OrderRequestSourceType.SOCIAL_TRADING = new OrderRequestSourceType(0 + 4)
// noinspection PointlessArithmeticExpressionJS
OrderRequestSourceType.TRADING_API = new OrderRequestSourceType(0 + 5)

export { OrderRequestSourceType };

/**
 * Fast Binary Encoding OrderRequestSourceType field model
 */
class FieldModelOrderRequestSourceType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelOrderRequestSourceType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelOrderRequestSourceType}
   * @param {OrderRequestSourceType=} defaults Default value, defaults is new OrderRequestSourceType()
   * @returns {!OrderRequestSourceType} Result value
   */
  get (defaults = new OrderRequestSourceType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new OrderRequestSourceType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelOrderRequestSourceType}
   * @param {!OrderRequestSourceType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelOrderRequestSourceType };
